import React, { useState } from "react";
import { CancelButton, SaveButton, DrawerComponent } from "@comps/components";
import { makeRequest, notify } from "@utils/helpers";
import { updateRoleReq } from "../requests";
import RoleForm from "./RoleForm";

const formName = "roles";
const UpdateRole = (props) => {
  const [loader, setLoader] = useState(false);
  const [errors, setErrors] = useState([]);

  const onFinish = (data) => {
    let payload = {
      "object": {
        id: props.data.id,
        name: data.name,
      }
    }
    makeRequest(setLoader, updateRoleReq, payload, onSuccess, onError);
  }

  const onSuccess = (data, res) => {
    notify("Role Updated", res.msg);
    props.onUpdated(data.object);
  }

  const onError = (err) => {
    let errorList = [];
    errorList['name'] = err.name;
  }

  return (
    <DrawerComponent mainTitle="Update" subTitle="Role" open={ true } footer={ false } onClose={ () => props.onClosed(false) }>
      <RoleForm setErrors={ setErrors } errors={ errors } initialData={ props.data } onFinish={ onFinish } formName={ formName } />
      <div className="form-actions">
        <CancelButton key="close_button" onClick={ () => props.onClosed(false) } />
        <SaveButton form={ formName } key="create_button" htmlType="submit" state={ loader } />
      </div>
    </DrawerComponent>
  );
}

export default UpdateRole
